import makeExpressionTransformer from 'automation-ui-formula-editor/formula-editor/grammar/makeExpressionTransformer';
import ExpressionTypes from 'automation-ui-formula-editor/formula-editor/grammar/constants/ExpressionTypes';
import { reportError } from 'automation-ui-core/errors/utils/reportError';
const binaryOperatorTransformer = ({
  expression: {
    left,
    right,
    operator
  },
  transformExpression
}) => {
  return `(${transformExpression(left)} ${operator} ${transformExpression(right)})`;
};
const functionTransformer = ({
  expression,
  transformExpression
}) => {
  // Special casing for legacy naked join functions that predate `storing formula syntax in HUBL comment` convention
  if (expression.name === 'join') {
    const elementsString = expression.arguments[0].elements.map(transformExpression).join(', ');
    if (expression.arguments.length === 2) {
      const delimiter = expression.arguments[1];
      return `join(${transformExpression(delimiter)}, ${elementsString})`;
    } else {
      return `concat(${elementsString})`;
    }
  }
  const argumentsString = expression.arguments.map(subExpression => transformExpression(subExpression)).join(', ');
  return `${expression.name}(${argumentsString})`;
};
const editorExpressionTransformer = makeExpressionTransformer({
  transformer: {
    [ExpressionTypes.FUNCTION_CALL]: functionTransformer,
    [ExpressionTypes.STRING_LITERAL]: ({
      expression
    }) => `"${expression.value}"`,
    [ExpressionTypes.NUMERIC_LITERAL]: ({
      expression
    }) => `${expression.value}`,
    [ExpressionTypes.FIELD]: ({
      expression
    }) => `[${expression.name}]`,
    [ExpressionTypes.ADD]: binaryOperatorTransformer,
    [ExpressionTypes.MULTIPLY]: binaryOperatorTransformer,
    [ExpressionTypes.DIVIDE]: binaryOperatorTransformer,
    [ExpressionTypes.SUBTRACT]: binaryOperatorTransformer,
    [ExpressionTypes.NEGATIVE]: ({
      expression: {
        argument
      },
      transformExpression
    }) => `-${transformExpression(argument)}`,
    [ExpressionTypes.POSITIVE]: ({
      expression: {
        argument
      },
      transformExpression
    }) => `${transformExpression(argument)}`,
    //Array types are intentionally unhandled. Any array expressions are expected to be transformed into a corresponding function expression
    [ExpressionTypes.ARRAY]: () => {
      reportError({
        error: new Error('Unexpected array expression encountered. ARRAY expressions should only exist in HUBL and be converted by `ExpressionMappings.js`')
      });
      return '';
    },
    [ExpressionTypes.ARRAY_ELEMENT]: () => {
      reportError({
        error: new Error('Unexpected array expression encountered. ARRAY_ELEMENT expressions should only exist in HUBL and be converted by `ExpressionMappings.js`')
      });
      return '';
    }
  }
});
export const toEditorExpression = (expression, options) => {
  if (expression && expression.comment) {
    return expression.comment;
  }
  return editorExpressionTransformer(expression, options);
};